<template>
  <b-container fluid>
    <div class="iq-card mt-3 px-3">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title py-3">
          <h4 class="card-title">Tank Header</h4>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right my-2">
              <button-options :access="'master_tank_header'" :hideAdd="false" :hideDetail="true"
                :isRefreshEnabled="true" :isRefreshed="isRefreshed" @onAddItemClicked="openAddForm"
                @onRefreshed="getData('Refreshed')" />
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="iq-card-body">
        <b-row>
          <b-col sm="12" md="4">
            <label for="" class="m-0">Company :</label>
            <b-form-select v-model="filter.tahdCompId" :options="companies" @change="getData('Refreshed')" class="mb-2" size="sm" placeholder="Select Company" />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <div class="table-responsive">
              <b-table striped hover fixed head-variant="dark" show-empty responsive :busy="isLoading" :fields="fields"
                :items="canRead('master_tank_header') ? data : []"
                style="border-radius: 10px; overflow: scroll; max-height: 500px;">
                <template v-slot:table-busy="">
                  <div class="text-center text-danger my-2">
                    <b-spinner variant="success" size="sm" class="align-middle"></b-spinner>
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <div class="text-center">
                    <button-options :access="'master_tank_header'" :hideAdd="true" :hideDelete="false"
                      :hideDetail="false" :hideEdit="false" @onViewClicked="openDetail(data.item)"
                      @onDeleteClicked="openDelete(data.item)" @onEditClicked="openEdit(data.item)" />
                  </div>
                </template>
              </b-table>

              <b-pagination v-model="pagination.current" :per-page="pagination.pageSize"
                :total-rows="pagination.totalSize" @change="onPageChanged"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-modal size="lg" hide-footer no-close-on-esc no-close-on-backdrop v-model="displayForm">
        <div class="iq-card mb-0" style="min-width: 300px;">
          <div class="iq-card-header d-flex justify-content-between">
            <div class="iq-header-title">
              <h4 class="card-title" v-if="!current.tahdId">Add New Tank Header</h4>
              <h4 class="card-title" v-if="current.tahdId">Edit Tank Header</h4>
            </div>
          </div>
          <div class="iq-card-body">
            <div class="row mb-3">
              <div role="group" class="form-group col-md-6">
                <label for="userId" class="d-block form-label text-left">
                  Company:
                </label>
                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <b-form-select v-model="current.tahdCompId" :options="companies"
                      :class="errors.tahdCompId ? 'is-invalid' : ''"></b-form-select>
                    <b-form-invalid-feedback v-if="errors.tahdCompId">
                      {{ Object.values(errors.tahdCompId) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>

              <div role="group" class="form-group col-md-6">
                <label for="tahdName" class="d-block form-label text-left">
                  Tank Header Name:
                </label>
                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <b-form-input v-model="current.tahdName" :class="errors.tahdName ? 'is-invalid' : ''"></b-form-input>
                    <b-form-invalid-feedback v-if="errors.tahdName">
                      {{ Object.values(errors.tahdName) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>

              <div role="group" class="form-group col-md-6">
                <label for="tahdUnit" class="d-block form-label text-left">
                  Unit:
                </label>
                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <b-form-input v-model="current.tahdUnit" :class="errors.tahdUnit ? 'is-invalid' : ''"></b-form-input>
                    <b-form-invalid-feedback v-if="errors.tahdUnit">
                      {{ Object.values(errors.tahdUnit) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>

              <div role="group" class="form-group col-md-6">
                <label for="tahdFuelType" class="d-block form-label text-left">
                  Fuel Type:
                </label>
                <div class="bv-no-focus-ring">
                  <div role="group" class="input-group">
                    <b-form-input v-model="current.tahdFuelType" :class="errors.tahdFuelType ? 'is-invalid' : ''"></b-form-input>
                    <b-form-invalid-feedback v-if="errors.tahdFuelType">
                      {{ Object.values(errors.tahdFuelType) }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <b-button @click="onCancel" class="mr-1" size="sm" :disabled="isSubmit" variant="outline-danger">
                <div class="mx-2">Cancel</div>
              </b-button>
              <b-button @click="onSubmitClicked" :disabled="isSubmit" variant="primary" size="sm"
                class="ml-1">
                <div class="mx-2">
                  <i v-if="isSubmit" class="ri-loader-line"></i>
                  Submit
                </div>
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal size="lg" hide-footer no-close-on-esc no-close-on-backdrop v-model="displayDeletion">
        <delete-item :isSubmit="isSubmit" @onCancelDeletion="displayDeletion = false"
          @onConfirmDeletion="onConfirmDeletion" />
      </b-modal>
    </div>
  </b-container>
</template>

<script>

import DeleteItem from '@/components/directives/delete-item';
import ButtonOptions from '@/components/directives/button-options';
import TankHeaderSvc from '@/services/TankHeaderSvc';
import TankDetailSvc from '@/services/TankDetailSvc';
import CompanySvc from '@/services/CompanySvc';

import requestBuilder from '@/util/master/request.builder';

export default {
  name: 'MasterTank',
  components: {
    DeleteItem, ButtonOptions,
  },
  data() {
    return {
      TankHeader: new TankHeaderSvc(),
      TankDetail: new TankDetailSvc(),
      companies: [],
      current: {},
      data: [],
      displayDeletion: false,
      displayForm: false,
      errors: {},
      isLoading: false,
      isRefreshed: false,
      isSubmit: false,
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 0,
      },
      filter: {},
      selected: {
        tahdCompId: null,
      },
      fields: [
        {
          key: 'tahdName',
          label: 'Tank Header Name',
          class: 'text-left',
        },
        {
          key: 'tahdUnit',
          label: 'Unit',
          class: 'text-left',
        },
        {
          key: 'tahdFuelType',
          label: 'Fuel Type',
          class: 'text-left',
        },
        {
          key: 'tahdComp.compName',
          label: 'Company',
          class: 'text-left',
        },
        {
          key: 'action',
          label: '',
          class: 'text-center',
        },
      ],
    };
  },
  methods: {
    async deleteData(notification, data) {
      this.isSubmit = true;
      try {
        const deleteResponse = await this.TankHeader.delete(data.tahdId);
        if (deleteResponse.status.error === 0) {
          this.$toast.success(notification);
          this.displayDeletion = false;
          this.pagination.current = 1;
          this.getData();
        } else {
          this.$toast.error(deleteResponse.status.message);
        }
      } catch (e) {
        this.$toast.error(e.message);
      } finally {
        this.isSubmit = false;
      }
    },
    async getData(notification) {
      try {
        this.isLoading = true;
        this.isRefreshed = true;

        const TankHeaderResponse = await this.TankHeader.getAll({
          ...requestBuilder.buildFilters(this.pagination, this.filter),
        });

        const Data = TankHeaderResponse.data;

        this.data = Data || [];

        this.pagination.totalSize = TankHeaderResponse.pagination?.totalData || 0;
        if (notification) {
          this.$toast.success(notification);
        }
      } catch (e) {
        console.error('get data error : ', e);
        this.$toast.error('Something wrong when fetching data');
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    onCancel() {
      this.current = {};
      this.displayForm = false;
    },
    onConfirmDeletion() {
      this.deleteData('Tank Header Deleted', this.selected);
    },
    onPageChanged(page) {
      this.pagination.current = page;
      this.getData();
    },
    async onSubmitClicked() {
      try {
        this.errors = {};
        this.isSubmit = true;

        const Data = {
          tahdName: this.current.tahdName,
          tahdUnit: this.current.tahdUnit,
          tahdFuelType: this.current.tahdFuelType,
          tahdCompId: this.current.tahdCompId,
        };

        if (Data.tahdCompId === null || Data.tahdCompId === undefined) {
          this.errors.tahdCompId = ['Company is required'];
        }

        if (Data.tahdName === null || Data.tahdName === undefined) {
          this.errors.tahdName = ['Tank Header Name is required'];
        }

        if (Data.tahdUnit === null || Data.tahdUnit === undefined) {
          this.errors.tahdUnit = ['Unit is required'];
        }

        if (Data.tahdFuelType === null || Data.tahdFuelType === undefined) {
          this.errors.tahdFuelType = ['Fuel Type is required'];
        }

        if (this.errors.tahdCompId || this.errors.tahdName || this.errors.tahdUnit || this.errors.tahdFuelType) {
          this.isSubmit = false;
          return;
        }

        if (!this.current.tahdId) { // jika tidak ada tahdId maka create
          const createResponse = await this.TankHeader.create(Data);

          if (createResponse.status.error === 0) {
            await this.getData('Success');
            this.current = {};
          } else {
            this.$toast.error('Error when saving data');
          }
        } else { // jika ada tahdId maka update
          const updateResponse = await this.TankHeader.update(this.current.tahdId, Data);

          if (updateResponse.status.error === 0) {
            await this.getData('Success');
            this.current = {};
          } else {
            this.$toast.error('Error when Update data');
          }
        }
        this.displayForm = false;
      } catch (e) {
        console.error('onSubmitClicked error : ', e);
        this.displayForm = false;
        this.$toast.error('Error when submiting data');
      } finally {
        this.isSubmit = false;
      }
    },
    openAddForm() {
      this.current = {};
      this.displayForm = true;
    },
    openDelete(data) {
      this.displayDeletion = true;
      this.selected = data;
    },
    openEdit(data) {
      this.displayForm = true;
      this.current = { ...this._.find(this.data, (v) => v.tahdId === data.tahdId) };
    },
    openDetail(data) {
      this.$router.push({ name: 'MasterTankDetail', params: { id: data.tahdId } });
    },
  },
  async mounted() {
    this.getData();
    const companyResponse = await CompanySvc.getCompanies({ params: { max: 100 } });
    this.companies = (companyResponse.data.data || []).map((comp) => ({ value: comp.compId, text: comp.compName }));
    this.companies = [...this.companies, { value: null, text: 'All' }];
  },
};
</script>
